<div class='footer'>
	<div class='container'>
		<div class='content'>

			<div class='inner-container'>
				<div class='desktop-buttons' [ngClass]="{'desktop-buttons-align-right' : formService.currentStep == 1 || ! formService.formActive}">

					<!-- Don't show button on first step -->
					<button class='back' type='button' *ngIf='formService.currentStep != 1 && formService.formActive && ! formService.formLoading' (click)='formService.back()'>
						<mat-icon svgIcon='icons:chevron-left'></mat-icon>
						<ng-container i18n='@@buttonBack'>Back</ng-container>
					</button>

					<!-- Button per step -->
					<ng-container *ngFor='let buttonName of buttonStepNames'>
						<button class='submit' type='submit' *ngIf='formService.currentFormGroupName == buttonName' [attr.form]='buttonName'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
					</ng-container>

					<button class='submit final' type='submit' *ngIf='formService.currentFormGroupName == "nameEmailPhone"' form='nameEmailPhone'><ng-container i18n='@@buttonFinish'>Get quotes</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>

					<!-- Third party questions -->
					<button class='submit-third-party' type='submit' *ngIf='formService.questionsActive' form='third-party-questions-form'><ng-container i18n='buttonSaveSelection'>Save</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
				</div>
			</div>
			<div class='footer-note' *ngIf='formService.showNote' i18n='@@movingDateTooFarAway'>Note: If your move is more than 9 months away, moving companies cannot yet provide you with a quote</div>
		</div>
	</div>
</div>
